<template>
  <MobileHeader />
  <SiteHeader />
  <router-view/>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import MobileHeader from '@/components/MobileHeader.vue';
import SiteHeader from '@/components/SiteHeader.vue';

export default defineComponent({
  name: 'App',
  components: {
    MobileHeader,
    SiteHeader
  }
});
</script>

<style lang="scss">
/* Global styles are now imported in main.ts */
</style>
